import { render, staticRenderFns } from "./UploadedDocumentItem.vue?vue&type=template&id=d0baa398&scoped=true"
import script from "./UploadedDocumentItem.vue?vue&type=script&lang=js"
export * from "./UploadedDocumentItem.vue?vue&type=script&lang=js"
import style0 from "./UploadedDocumentItem.vue?vue&type=style&index=0&id=d0baa398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0baa398",
  null
  
)

export default component.exports